import React from 'react';

import { Badge, Tooltip } from 'antd';

import styled from 'styled-components';

import { showDateNoTime } from '@libs/NwMoment';

import NwIcon from '@components/Gui/NwIcon';
import StyleVariables from '@components/Gui/StyleVariables';
import { getSubjectStatementStatus } from '@components/StatementRowsCommon/helpers';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const Wrapper = styled.span`
    font-size: ${(props) => (props.$small ? '1.1rem' : '1.25rem')};
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 2.5rem;
    color: ${(props) => (props.$green ? props.theme.SuccessColor : props.theme.TextColor)};

    .ant-badge {
        padding: 0 0.15rem;
        .ant-badge-status-dot {
            width: ${(props) => (props.$small ? '.6rem' : '.75rem')};
            height: ${(props) => (props.$small ? '.6rem' : '.75rem')};
        }
    }
`;

const StatementStatusIcon = ({ additionalText, onInvoiceClick, statement, statusModel, small }) => {
    const ColorMap = {
        option: StyleVariables.WarningColor,
        job: StyleVariables.DangerColor,
        billable: StyleVariables.SuccessColor,
    };
    const TextMap = {
        option: 'Option',
        job: 'Confirmed',
        billable: 'To Bill',
    };
    const addtxt = () => {
        if (additionalText) {
            return additionalText + ' - ';
        }
        return '';
    };

    const resolvedStatus = statusModel || getSubjectStatementStatus(statement);
    const hasInvoiceClick = typeof onInvoiceClick === 'function' && Boolean(resolvedStatus.invoiceId);

    const handleInvoiceClick = (event) => {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (hasInvoiceClick) {
            onInvoiceClick(resolvedStatus.invoiceId);
        }
    };

    const Content = () => {
        const { state, invoiceNumber, invoiceDate, paidState } = resolvedStatus;

        if (!state) {
            return null;
        }

        if (paidState === 'paid') {
            return (
                <Tooltip title={`${addtxt()}Invoice #${invoiceNumber} - ${showDateNoTime(invoiceDate)} - PAID`}>
                    <Wrapper $small={small} $green>
                        {hasInvoiceClick ? (
                            <NwIcon icon={byPrefixAndName.fass['check']} pointer onClick={handleInvoiceClick} />
                        ) : (
                            <NwIcon icon={byPrefixAndName.fass['check']} />
                        )}
                    </Wrapper>
                </Tooltip>
            );
        }

        switch (state) {
            case 'invoiced':
                return (
                    <Tooltip title={`${addtxt()}Invoice #${invoiceNumber} - ${showDateNoTime(invoiceDate)}`}>
                        <Wrapper $small={small}>
                            {hasInvoiceClick ? (
                                <NwIcon
                                    icon={byPrefixAndName.fasl['file-invoice']}
                                    pointer
                                    onClick={handleInvoiceClick}
                                />
                            ) : (
                                <NwIcon icon={byPrefixAndName.fasl['file-invoice']} />
                            )}
                        </Wrapper>
                    </Tooltip>
                );
            case 'locked':
                return (
                    <Tooltip title={`${addtxt()}Locked - In a invoice draft`}>
                        <Wrapper $small={small}>
                            {hasInvoiceClick ? (
                                <NwIcon icon={byPrefixAndName.fasl['lock']} pointer onClick={handleInvoiceClick} />
                            ) : (
                                <NwIcon icon={byPrefixAndName.fasl['lock']} />
                            )}
                        </Wrapper>
                    </Tooltip>
                );
            default:
                return (
                    <Tooltip title={`${addtxt()}${TextMap[state] || state}`}>
                        <Wrapper $small={small}>
                            <Badge color={ColorMap[state]} />
                        </Wrapper>
                    </Tooltip>
                );
        }
    };
    return <Content />;
};

export default StatementStatusIcon;
